import { h } from 'preact';
import dlv from 'dlv';
import style from './style';
import pageStyles from '../../../pageStyles';

import SimpleGridCluster from '../../../../clusters/simple-grid-cluster';
import CategoryCluster from '../../../../clusters/category-cluster';
import RecommendedCluster from '../../../../clusters/recommended-cluster';
import PromoCluster from '../../../../clusters/promo-cluster';
import SupportClusterP23 from '../../../../clusters/support-cluster-p23';
import { TopBorder } from '../../../../pieces/top-border';
import { SadlibAd } from '../../../../pieces/sadlib-ad';
import { TaboolaJs } from '../../../../pieces/taboola-js';
import { getCommonProps } from '../../../../../lib/page';

import { Row, Column, Section, ContainerFluid } from '@cube/layout';
import { MobileHeader } from '@cube/header-widget';
import Notifications from '@cube/notifications';
import { DccWidget } from '@cube/dcc-widget-v2';

export const Tablet = ({ pageConfig, ...props }) =>
	(
		<div class={style.tablet}>
			<MobileHeader
				{...props}
				{...pageConfig.header}
			/>
			<ContainerFluid>
				<Section containerClass={pageStyles.defaultTabletPageWidth}>
					<Notifications
						alertClass={style.notification}
						{...getCommonProps(props)}
					/>
					<SadlibAd id="sc_home_tablet_masthead" type="desktopBanner" />
					<Row>
						<Column>
							<DccWidget
								{...dlv(pageConfig, 'clusters.dcc')}
								{...getCommonProps(props)}
							/>
						</Column>
						<Column class={style.sideDcc}>
							<TaboolaJs {...dlv(pageConfig, 'taboola.subDcc')} qeId="sc-home-sidedcc" />
						</Column>
					</Row>
					<Row class={style.clusters}>
						<Column>
							<SimpleGridCluster
								{...dlv(pageConfig, 'clusters.spotlight')}
								qeId="sc-home-spotlight"
								imageRole="w=256,h=144"
								rowCount={1}
								columnCount={4}
								titleLines={3}
								{...getCommonProps(props)}
							/>
							<SupportClusterP23
								{...dlv(pageConfig, 'clusters.support')}
								layout="tablet"
								qeId="sc-home-alerts"
								{...getCommonProps(props)}
							/>
							{ dlv(pageConfig, 'clusters.promo') &&
								<PromoCluster
									{...dlv(pageConfig, 'clusters.promo')}
									{...getCommonProps(props)}
								/>
							}
							<TopBorder />
							<RecommendedCluster
								{...dlv(pageConfig, 'clusters.recommended')}
								qeId="sc-home-recommended"
								{...getCommonProps(props)}
							/>
							<SadlibAd id="sc_home_tablet_1" type="desktopBanner" />
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestEntertainment')}
								qeId="sc-home-entertainment"
								{...getCommonProps(props)}
							/>
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestHealth')}
								qeId="sc-home-latestHealth"
								{...getCommonProps(props)}
							/>
							<div>
								<SadlibAd id="sc_home_tablet_2" type="desktopBanner" />
								<TopBorder />
								<CategoryCluster
									{...dlv(pageConfig, 'clusters.latestNews')}
									qeId="sc-home-news"
									{...getCommonProps(props)}
								/>
								<SadlibAd id="sc_home_tablet_3" type="desktopBanner" />
								<TopBorder />
								<CategoryCluster
									{...dlv(pageConfig, 'clusters.latestSports')}
									qeId="sc-home-sports"
									{...getCommonProps(props)}
								/>
								<SadlibAd id="sc_home_tablet_4" type="desktopBanner" />
								<TopBorder />
								<CategoryCluster
									{...dlv(pageConfig, 'clusters.latestBusiness')}
									qeId="sc-home-business"
									{...getCommonProps(props)}
								/>
								<TaboolaJs {...dlv(pageConfig, 'taboola.bottomPage')} qeId="sc-home-taboolabottompage" />
							</div>
						</Column>
					</Row>
				</Section>
				<SadlibAd id="adhesion" />
			</ContainerFluid>
		</div>
	);
